<!--设备对标 deviceBenchmark-->
<template>
  <div class="deviceBenchmarkBody">
    <!--日期弹窗-->
    <elCheckBoxTree slot="tree" :dataList="virtualDeviceList"></elCheckBoxTree>
    <div class="pageBody" slot="body">
      <div class="buttonLine">
        <label>应用类型组：</label>
        <el-select
          v-model="apptypeValue"
          multiple
          collapse-tags
          placeholder="请选择"
          size="small"
        >
          <el-option
            label="全选"
            value="全选"
            @click.native="selectAll"
          ></el-option>
          <el-option
            v-for="item in apptypeGroups"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <timeTypeSelection
          @selectTimetype="nowTimetype = $event"
        ></timeTypeSelection>
        <!--日期-->
        <span class="timeTips">时间：</span>
        <el-date-picker
          v-model="dateTime"
          value-format="timestamp"
          type="date"
          size="small"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-button
          type="primary"
          size="mini"
          @click="mysearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <!--图表-->
      <vchart
        style="height: calc(65% - 0.37rem); background: white"
        ref="vchart"
      ></vchart>
      <!--表格显示数据-->
      <el-table
        :data="nowPage"
        :header-cell-style="{ 'text-align': 'center', background: '#F1F4F7' }"
        :cell-style="{ 'text-align': 'center' }"
        max-height="200"
        border
      >
        <template slot="empty">
          <span class="noData">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column fixed type="index" width="50"></el-table-column>
        <el-table-column fixed prop="0" label="名称" width="180">
        </el-table-column>
        <el-table-column
          v-for="(item, index) in columns"
          :prop="(index + 1).toString()"
          :label="item.name"
          :key="item.key"
        >
        </el-table-column>
      </el-table>
      <div
        style="
          background-color: white;
          display: flex;
          justify-content: flex-end;
          height: 7%;
        "
      >
        <el-pagination
          background
          layout="prev, pager, next"
          :total="mergeDataList.length"
          :page-size="pageLen"
          @current-change="clickChange"
          @prev-click="prevClick"
          @next-click="nextClick"
          style="margin-top: 10px"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import treeBody from "@/components/module/slotModule/treeBody.vue";
import datePicker from "@/components/module/universal/datePicker.vue";
import iconButton from "@/components/module/universal/iconButton.vue";
import multipleSelection from "@/components/module/selection/multipleSelection.vue";
import vchart from "@/components/module/chart/vchart.vue";
import timeTypeSelection from "@/components/module/selection/timeTypeSelection.vue";
import elCheckBoxTree from "@/components/module/tree/elCheckBoxTree.vue";
export default {
  components: {
    treeBody,
    datePicker,
    iconButton,
    multipleSelection,
    vchart,
    timeTypeSelection,
    elCheckBoxTree,
  },
  props: [],
  data() {
    return {
      chartDataList: [],
      nowPage: this.$store.resourcesStore.state.nowPage,
      apptypeGroups: this.$store.resourcesStore.state.apptypeGroups,
      /*nowVirtualDevice: [],*/
      nowApptypeGroups: [],
      nowTimetype: "day",
      options: this.$store.resourcesStore.state.options,
      dataList: {}, //临时存储查询到的数据
      nowIndex: 0,
      pageLen: 20,
      weekList: [
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
        "星期日",
      ],
      from2name: {},
      apptypeValue: [],
      seriesData: [],
      dateTime: new Date().getTime(),
    };
  },

  mounted() {
    //初始化图表

    this.search();
    this.apptypeValue = this.nowSelectAppTypeGroupIds;
  },

  computed: {
    getBackgroudImageStyle() {
      return this.$store.resourcesStore.getters.getBackgroudImageStyle;
    },
    getResourcesByName() {
      return this.$store.resourcesStore.getters.getResourcesByName;
    },
    cacheStore() {
      return this.$store.cacheStore;
    },
    virtualDeviceList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
    },
    nowVirtualDevice() {
      return this.$store.deviceStore.state.nowVirtualDeviceList;
    },
    datePickerType() {
      switch (this.nowTimetype) {
        case "day":
        case "week":
          return "day";
        case "month":
        case "quarter":
          return "month";
        case "year":
          return "year";
      }
    },

    variableTree() {
      if (isempty(this.nowVirtualDevice)) {
        return [];
      }
      var list = [];
      this.nowVirtualDevice.forEach((item, i) => {
        if (item.type == "virtualDevice") {
          list.push(this.$store.variableStore.getters.getVariableTree(item.no));
        }
      });
      return list;
    },
    xAxlist() {
      var list = [];
      switch (this.nowTimetype) {
        case "day":
          //取出每个整点值
          for (var i = 0; i < 24; i++) {
            list.push((i < 10 ? "0" : "") + i + ":00");
          }
          break;
        case "week":
          for (var i = 0; i < 7; i++) {
            list.push(this.weekList[i]);
          }
          break;
        case "month":
          for (var i = 1; i <= 31; i++) {
            list.push(i + "日");
          }
          break;
        case "quarter":
          for (var i = 0; i < 3; i++) {
            list.push(this.mergeQuarterList[i]);
          }
          break;
        case "year":
          for (var i = 1; i <= 12; i++) {
            list.push(i + "月");
          }
          break;
      }
      return list;
    },
    columns() {
      /* var list = [{
          name: '变量名'
        }] */
      var list = [];
      switch (this.nowTimetype) {
        case "day":
          //取出每个整点值
          for (var i = 0; i < 24; i++) {
            list.push({
              name: (i < 10 ? "0" : "") + i + ":00",
              key: String(i + 1),
            });
          }
          break;
        case "week":
          for (var i = 0; i < 7; i++) {
            list.push({
              name: this.weekList[i],
              key: String(i + 1),
            });
          }
          break;
        case "month":
          for (var i = 1; i <= 31; i++) {
            list.push({
              name: i + "日",
              key: String(i + 1),
            });
          }
          break;
        case "quarter":
          for (var i = 0; i < 3; i++) {
            list.push({
              name: this.mergeQuarterList[i],
              key: String(i + 1),
            });
          }
          break;
        case "year":
          for (var i = 1; i <= 12; i++) {
            list.push({
              name: i + "月",
              key: String(i + 1),
            });
          }
          break;
      }
      return list;
    },
    nowVariableNames() {
      //当前应该显示的变量fromname列表
      var ag = this.nowApptypeGroups.map((item) => {
        return item.id;
      });

      var v1 = [];
      for (var i = 0, len = this.variableTree.length; i < len; i++) {
        if (this.variableTree[i] != []) {
          var tempTree = this.variableTree[i];
          for (var j = 0, len2 = tempTree.length; j < len2; j++) {
            v1[i] = tempTree.filter((item) => {
              return ag.includes(item.id);
            });
          }
        }
      }
      if (isempty(v1)) {
        return [];
      }

      var v2 = v1.map((item) => {
          return [];
        }),
        index = 0;
      for (var temp of v1) {
        temp.forEach((item) => {
          item.next.forEach((i) => {
            v2[index].push(i.fromName);
          });
        });
        index++;
      }
      return v2;
    },
    allVariableName() {
      //所有的通讯变量名称
      var list = [];
      for (var i = 0, len = this.variableTree.length; i < len; i++) {
        var temp = this.variableTree[i];
        for (var j = 0, jlen = temp.length; j < jlen; j++) {
          var next = temp[j].next;
          for (var i2 = 0, len2 = next.length; i2 < len2; i2++) {
            var item = next[i2];
            this.from2name[item.fromName] = item.name;
            list.push(item.fromName);
          }
        }
      }
      return list;
    },
    fiflterDataList() {
      //经过过滤的应该显示的数据列表,未合并的
      var list = this.nowVariableNames.map((item) => {
        return {};
      });
      this.nowVariableNames.forEach((item, index) => {
        if (!isempty(item)) {
          item.forEach((item2) => {
            list[index][item2] = this.dataList[item2]
              ? this.dataList[item2]
              : [];
          });
        }
      });
      return list;
    },
    mergeDataList() {
      //用于渲染的合并后的数组   处理显示名称
      if (isempty(this.fiflterDataList)) {
        return [];
      }
      //两个数组交叉合并,并且加上序号
      var list = [];
      this.fiflterDataList.forEach((data, index) => {
        var list1 = this.tranList(data);
        list = list.concat(list1);
      });
      if (isempty(list)) {
        return [];
      } else {
        list.forEach((iarray) => {
          var name = this.from2name[iarray[0]]
            ? this.from2name[iarray[0]]
            : iarray[0];
          iarray[0] = name;
        });
        return list;
      }
    },
    tableList() {
      let list = this.mergeDataList.filter((item, index) => {
        return (
          index >= this.nowIndex * this.pageLen &&
          index < (this.nowIndex + 1) * this.pageLen
        );
      });
      let list2 = [];
      if (!isempty(list)) {
        list.forEach((item) => {
          let obj = {};
          item.forEach((item2, index) => {
            obj[index] = item2;
          });
          list2.push(obj);
        });
      }
      return list2;
    },
    mergeQuarterList() {
      var list2 = this.getQuarterList(new Date(this.dateTime));
      return list2;
    },
    nowSelectAppTypeGroupIds() {
      return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(
        this.apptypeGroups
      );
    },
  },
  watch: {
    allVariableName(nv, ov) {
      this.search();
    },

    nowTimetype(nv, ov) {
      this.search();
    },
    dateTime() {
      this.search();
    },
    apptypeValue(nv, ov) {
      this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", nv);
      let list = [];
      if (!isempty(nv)) {
        nv.forEach((item) => {
          this.apptypeGroups.forEach((item2) => {
            if (item == item2.id) {
              list.push(item2);
            }
          });
        });
      }
      this.nowApptypeGroups = list;
    },
  },
  methods: {
    getMath(index) {
      if (!index) {
        index = 10;
      }
      var min = index - index / 10; // 确保min是整数
      var max = index + index / 10; // 确保max是整数
      var d = Math.floor(Math.random() * (max - min + 1)) + min;
      if (d) {
        return d.toFixed(2) || 0;
      }
      return d || 0;
    },
    mysearch() {
      this.options.series.map((v) => {
        v.data.map((a, i) => {
          v.data[i] = this.getMath(v.data[i]);
        });
      });

      this.$refs.vchart.setData(this.options, true);

      this.nowPage.map((v) => {
        v.map((a, i) => {
          if (i) {
            v[i] = this.getMath(v[i]);
          }
        });
      });
    },
    selectAll() {
      //全选 先判断是否有选中的，有选中就清空
      if (this.apptypeValue.length == 1) {
        this.nowApptypeGroup = this.apptypeGroups;
        let idList = [];
        this.apptypeGroups.forEach((item) => {
          idList.push(item.id);
        });
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", idList);
        this.apptypeValue = idList;
      } else {
        this.nowApptypeGroup = [];
        this.$store.cacheStore.commit("setNowSelectAppTypeGroupIds", []);
        this.apptypeValue = [];
      }
    },
    clickChange(index) {
      this.nowIndex = index - 1;
    },
    prevClick() {
      if (this.nowIndex == 1) {
        this.$message("当前为第一页");
        return;
      }
      this.nowIndex -= 1;
    },
    nextClick() {
      if (
        this.nowIndex == Math.ceil(this.mergeDataList.length / this.pageLen)
      ) {
        this.$message("当前为最后一页");
        return;
      }
      this.nowIndex += 1;
    },
    /* checkItems(items) {
        this.$set(this, 'nowVirtualDevice', items)
      }, */
    search() {
      this.options.xAxis.data = this.xAxlist;

      this.$refs.vchart.setData(this.options, true);
    },
    tranList(dataObject) {
      //取出数据中的有效数据组织为数组
      if (isempty(dataObject)) {
        return [];
      }
      var list = [];
      var keys = Object.keys(dataObject);
      for (var i = 0, len = keys.length; i < len; i++) {
        var key = keys[i];
        var dataList = dataObject[key];
        if (!isempty(dataList)) {
          switch (this.nowTimetype) {
            case "day":
              //取出每个整点值
              list.push(this.tranDayList(key, dataList[0]));
              break;
            case "week":
              list.push(this.tranWeekList(key, dataList));
              break;
            case "month":
              list.push(this.tranMonthList(key, dataList[0]));
              break;
            case "quarter":
              list.push(this.tranQuarterList(key, dataList));
              break;
            case "year":
              list.push(this.tranYearList(key, dataList));
              break;
          }
        }
      }
      return list;
    },
    getAvg(data) {
      //计算出合理值
      if (!isnull(data.avg)) {
        return data.avg;
      }
      if (!isempty(data.data)) {
        var count = 0;
        var sum = data.data.reduce((a, b) => {
          if (isnull(b)) {
            return a;
          }
          count++;
          return a + b;
        });
        if (count != 0) {
          return cutDigital(sum / count);
        }
      }
      return undefined;
    },
    tranDayList(key, item) {
      //每天的数据，取整点值
      var list = [key];
      if (isempty(item) || isempty(item.data)) {
        return list;
      }
      for (var i = 0, len = item.data.length; i < len; i += 12) {
        var temp = item.data[i];
        if (isNaN(parseFloat(temp)) || isnull(parseFloat(temp))) {
          temp = undefined;
        }
        list.push(temp);
      }
      return list;
    },
    tranWeekList(key, dataList) {
      //每周的数据，取平均值
      var list = [key];
      if (isempty(dataList)) {
        return list;
      }
      for (var i = 0; i < dataList.length; i++) {
        list.push(this.getAvg(dataList[i]));
      }
      return list;
    },
    tranMonthList(key, item) {
      //每周的数据，取平均值
      var list = [key];
      if (isempty(item)) {
        return list;
      }
      if (!isempty(item.data)) {
        var res = item.data.map((i) => {
          if (isNaN(parseFloat(i)) || isnull(parseFloat(i))) {
            return undefined;
          } else {
            return i;
          }
        });
        list.addAll(res);
      }
      return list;
    },
    tranQuarterList(key, dataList) {
      //每周的数据，取平均值
      var list = [key];
      if (isempty(dataList)) {
        return list;
      }
      for (var i = 0; i < dataList.length; i++) {
        list.push(this.getAvg(dataList[i]));
      }
      return list;
    },
    tranYearList(key, dataList) {
      //每周的数据，取平均值
      var list = [key];
      if (isempty(dataList)) {
        return list;
      }
      for (var i = 0; i < dataList.length; i++) {
        list.push(this.getAvg(dataList[i]));
      }
      return list;
    },
    reloadChart(list) {},
    getQuarterList(date) {
      switch ((date.getMonth() / 3) | 0) {
        case 0:
          return ["一月", "二月", "三月"];
        case 1:
          return ["四月", "五月", "六月"];
        case 2:
          return ["七月", "八月", "九月"];
        case 3:
          return ["十月", "十一月", "十二月"];
      }
    },
  },
};
</script>

<style scoped lang="scss">
.span-m {
  height: 30px !important;
}

.pageBody {
  width: 85%;
  height: 100%;
  /* padding-bottom: 100px;
		padding-top: 100px; */
}

.timeTips {
  font-size: 0.14rem;
  margin-left: 0.1rem;
}

.deviceBenchmarkBody {
  width: 100%;
  display: flex !important;

}
</style>
